// extracted by mini-css-extract-plugin
export const wrapper = "Contact-module--wrapper--3_Va4";
export const contentWrapper = "Contact-module--contentWrapper--moer3";
export const content = "Contact-module--content--1nE18";
export const imageWrapper = "Contact-module--imageWrapper--3ScpQ";
export const headline = "Contact-module--headline--Igwsh";
export const text = "Contact-module--text--EA2Bj";
export const contactInfo = "Contact-module--contactInfo--7nU_h";
export const divider = "Contact-module--divider--HCMDb";